import { render, staticRenderFns } from "./AssetImpairment.vue?vue&type=template&id=b4eb7690&scoped=true"
import script from "./AssetImpairment.vue?vue&type=script&lang=js"
export * from "./AssetImpairment.vue?vue&type=script&lang=js"
import style0 from "./AssetImpairment.vue?vue&type=style&index=0&id=b4eb7690&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4eb7690",
  null
  
)

export default component.exports